export default __webpack_public_path__ + "media/Seasoning-Syrup.e3db87c3.png";